import React from 'react'
import { Route, Routes } from 'react-router-dom'
import FinanceDayBookPage from '../app/admin/erp/finance/reports/pages/FinanceDayBookPage'
import GSTR1Page from '../app/admin/erp/finance/reports/pages/GSTR1Page'
import GSTR2Page from '../app/admin/erp/finance/reports/pages/GSTR2Page'
import GSTR3BPage from '../app/admin/erp/finance/reports/pages/GSTR3BPage'


function FinanceReportRoutes() {
  return (
    <Routes>
        <Route path="/finance/report/daybook" element={<FinanceDayBookPage /> }></Route>
        <Route path="/finance/report/gstr1" element={<GSTR1Page /> }></Route>
        <Route path="/finance/report/gstr2" element={<GSTR2Page /> }></Route>
        <Route path="/finance/report/gstr3b" element={<GSTR3BPage /> }></Route>
    </Routes>
  )
}

export default FinanceReportRoutes